import React, { useState } from "react";
import { Button, CircularProgress, Alert, Stack } from "@mui/material";
import { useApi } from "../../utils/api";
import { useUserInfo } from "../../utils/user";

export default function ConnectInstagramButton() {
  const { getInstagramAuthUrl } = useApi();
  const { id: userId } = useUserInfo();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const connect = async () => {
    if (!userId) {
      setError("User not logged in");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const j = await getInstagramAuthUrl(userId);
      if (j.error) throw new Error(j.error || "Failed to get auth url");

      // Save state locally so callback can send it (optional)
      if (j.state) localStorage.setItem("ig_oauth_state", j.state);

      window.location.href = j.url;
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  return (
    <Stack spacing={2}>
      {error && <Alert severity="error">{error}</Alert>}
      <Button
        variant="contained"
        onClick={connect}
        disabled={loading || !userId}
        startIcon={loading ? <CircularProgress size={18} /> : null}
      >
        Connect Instagram
      </Button>
    </Stack>
  );
}
